import { fetchPageState } from '../utilities/fetch-api';

export async function mfaEnrollmentLoader({ request }: { request: Request }) {
  const pageUrl = new URL(request.url);
  let token = pageUrl.searchParams.get('token');

  if (!token) {
    const continueUrl = pageUrl.searchParams.get('continue');
    if (continueUrl) {
      try {
        token = new URL(continueUrl).searchParams.get('token');
      } catch {
        // The page handles malformed continue URLs; the state request remains tokenless.
      }
    }
  }

  const stateRequestUrl = new URL(pageUrl);
  stateRequestUrl.search = '';
  if (token) {
    stateRequestUrl.searchParams.set('token', token);
  }

  return await fetchPageState('/rest/2step/enrollment/state', new Request(stateRequestUrl), {
    capabilities: ['capability-group--login', 'capability-name--mfa'],
    throwOnClientError: true,
  });
}
